import { useMemo } from 'react';

import { POPUP_WINDOW_PREFIX } from '@lib/utils';

export function useIsPopupWindow(): boolean {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.name?.startsWith(POPUP_WINDOW_PREFIX) ?? false;
  }, []);
}
